import React, { memo } from 'react';
import { useSearchParams } from 'react-router-dom';

import DefaultButton from 'components/atoms/DefaultButton';
import { SEARCH_PARAMS } from 'constants/search-params';

function BackOfficeUserCreateButton(): JSX.Element {
  const [, setSearchParams] = useSearchParams();

  const handleClick = () => {
    setSearchParams((prev) => {
      const newSearchParams = new URLSearchParams(prev);
      newSearchParams.delete(SEARCH_PARAMS.BACK_OFFICE.SELECTED_USER);
      newSearchParams.delete(SEARCH_PARAMS.INVITATION_EMAIL);
      newSearchParams.set(SEARCH_PARAMS.DRAWER.key, SEARCH_PARAMS.DRAWER.values.ADD_USER);
      return newSearchParams;
    });
  };

  return (
    <DefaultButton
      type="primary"
      size="small"
      onClick={handleClick}
      mobileChildren="INVITE"
    >
      INVITE USER
    </DefaultButton>
  );
}

export default memo(BackOfficeUserCreateButton);
